import treasure1 from "./treasure1.png";
import treasure2 from "./treasure2.png";
import treasure3 from "./treasure3.png";
import treasure4 from "./treasure4.png";
import treasure5 from "./treasure5.png";
import treasure6 from "./treasure6.png";
import treasure7 from "./treasure7.png";
import treasure8 from "./treasure8.png";
import treasure9 from "./treasure9.png";
import treasure10 from "./treasure10.png";
import treasure11 from "./treasure11.png";

export const treasures: {[keys: string]: any} = {
  treasure1,
  treasure2,
  treasure3,
  treasure4,
  treasure5,
  treasure6,
  treasure7,
  treasure8,
  treasure9,
  treasure10,
  treasure11
}
